import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BanknotesIcon } from '@heroicons/react/24/outline';
export const CreditBalance = ({ available, total, allocated = 0, className = '', size = 'md', showDetails = false, }) => {
    const percentage = total > 0 ? (available / total) * 100 : 0;
    const sizeClasses = {
        sm: {
            icon: 'h-4 w-4',
            text: 'text-sm',
            number: 'text-lg',
        },
        md: {
            icon: 'h-5 w-5',
            text: 'text-base',
            number: 'text-2xl',
        },
        lg: {
            icon: 'h-6 w-6',
            text: 'text-lg',
            number: 'text-3xl',
        },
    };
    const getColorClass = () => {
        if (percentage > 50)
            return 'text-green-600';
        if (percentage > 20)
            return 'text-yellow-600';
        return 'text-red-600';
    };
    return (_jsxs("div", { className: `flex items-center gap-3 ${className}`, children: [_jsx("div", { className: "flex-shrink-0", children: _jsx("div", { className: `rounded-full bg-primary/10 p-2 ${getColorClass()}`, children: _jsx(BanknotesIcon, { className: sizeClasses[size].icon }) }) }), _jsxs("div", { className: "flex-1", children: [_jsxs("div", { className: "flex items-baseline gap-2", children: [_jsx("span", { className: `font-bold ${sizeClasses[size].number} ${getColorClass()}`, children: available.toLocaleString() }), _jsx("span", { className: `${sizeClasses[size].text} text-gray-500`, children: "credits available" })] }), showDetails && (_jsxs("div", { className: `${sizeClasses[size].text} text-gray-600 mt-1 space-y-0.5`, children: [_jsxs("div", { className: "flex justify-between", children: [_jsx("span", { children: "Total owned:" }), _jsx("span", { className: "font-medium", children: total.toLocaleString() })] }), _jsxs("div", { className: "flex justify-between", children: [_jsx("span", { children: "Allocated to workspaces:" }), _jsx("span", { className: "font-medium", children: allocated.toLocaleString() })] })] })), _jsx("div", { className: "mt-2 h-2 w-full bg-gray-200 rounded-full overflow-hidden", children: _jsx("div", { className: `h-full transition-all duration-300 ${percentage > 50 ? 'bg-green-500' :
                                percentage > 20 ? 'bg-yellow-500' :
                                    'bg-red-500'}`, style: { width: `${Math.max(0, Math.min(100, percentage))}%` } }) })] })] }));
};
//# sourceMappingURL=CreditBalance.js.map